module.exports = __webpack_public_path__ + "static/media/CSVProjectExample.0473a617.csv";